<script>
import toggleModal from '@/mixins/toggleModal';
import { mapActions, mapState } from 'vuex';
import UploadImages from '@/components/ux/upload/Upload-image.vue';

export default {
  components: { UploadImages },
  data() {
    return {
      files: [],
    };
  },
  mixins: [toggleModal],
  methods: {
    ...mapActions({
      addGiftCardImageAction: 'products/createCardImage',
    }),
    handleOk(values) {
      if (this.Images && this.Images.length) {
        this.addGiftCardImageAction({
          ...values,
          file: this.files[0],
          index: this.Images[this.Images.length - 1].index + 1,
        });
      } else {
        this.addGiftCardImageAction({
          ...values,
          file: this.files[0],
          index: 0,
        });
      }
      this.hideModal();
    },
  },
  computed: {
    ...mapState({
      Images: (state) => state.products.cardImages,
    }),
  },
};
</script>

<template>
  <a-modal :open="show" :footer="null" @cancel="hideModal" >
    <div>
      <h1 class="text-2xl font-bold mb-2">Create new gift card image</h1>
      <upload-images v-model:files="files" :is-multiple="false" />
      <FormKit
        type="form"
        submit-label="Add new gift card image"
        @submit="handleOk"
      >
        <FormKit
          type="text"
          name="name"
          label="Name gift card"
          placeholder="Enter name card"
          validation="required"
        />
      </FormKit>
    </div>
  </a-modal>
</template>

<style scoped lang="scss">
.image-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.img {
  width: 100px;
  height: 100px;
}
</style>
